import React from "react";

export interface LineListEntry {
  name: string;
  pheno: string | number;
  config: string;
  checked: boolean;
}
interface DevicePhenomenaSelectorProps {
  lineList: LineListEntry[];
  setLineList: (lines: LineListEntry[]) => void;
}

const DevicePhenomenaSelector: React.FC<DevicePhenomenaSelectorProps> = ({
  lineList,
  setLineList,
}) => {
  return (
    <div>
      {lineList.map((item, index) => (
        <div
          key={item.config}
          onClick={() => {
            const updated = [...lineList];
            updated[index] = { ...updated[index], checked: !updated[index].checked };
            setLineList(updated);
          }}
        >
          <input type="checkbox" checked={item.checked} readOnly />
          <label className="ml-2">{item.name}</label>
        </div>
      ))}
    </div>
  );
};

export default DevicePhenomenaSelector;
